import Cookies from "universal-cookie";

import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGOUT,
  CLEAR_AUTH_ERRORS,
} from "../types";

const cookie = new Cookies();

export default (state, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      cookie.set("token", action.payload.token);
      return {
        ...state,
        token: action.payload.token,
        isAuthenticated: true,
        loading: false,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: action.payload,
      };
    case CLEAR_AUTH_ERRORS:
      return {
        ...state,
        errors: null,
        info: null,
      };
    case AUTH_ERROR:
    case LOGOUT:
    case LOGIN_FAIL:
      cookie.remove("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        errors: action.payload,
        info: null,
      };
    default:
      return state;
  }
};
